import { StateObj } from 'src/types'

type PriceStateObj = StateObj & {
  price: number
}

const hasPrice = (item: StateObj): item is PriceStateObj => {
  return 'price' in item && typeof item?.price === 'number'
}

export const dummy = {
  head: 'dummy',
  label: 'dummy',
  value: 'dummy'
}

export const getBaseCell = (head: string, item: StateObj, hidePrice = false) => {
  if (hasPrice(item) && !hidePrice) {
    return { head, label: `${item?.label} (+${item?.price.toLocaleString()}円)`, value: item?.value }
  }
  return { head, label: item?.label, value: item?.value }
}

export const getColorCell = (head: string, stateObj: StateObj, partsKey: string) => ({
  head,
  label: stateObj?.label,
  color: stateObj?.color,
  value: stateObj?.value,
  partsKey
})
